import { Box } from "@mui/material"
import React from "react"
import { LinearLoader } from "ui/components/LinearLoader"

interface IPageLoadingProps {
  title: string
  id?: string
  className?: string
  sx?: any
  noMargin?: boolean
}

export const PageLoading = React.memo(({ className, id, title, sx, noMargin }: IPageLoadingProps) => (
  <Box
    id={id}
    className={className}
    sx={{
      width: "100%",
      heigth: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      ...sx
    }}>
    <LinearLoader
      text={title}
      sx={{
        marginsLeft: noMargin ? undefined : "30%",
        marginsRight: noMargin ? undefined : "30%",
        maxWidth: noMargin ? undefined : "59%"
      }}
      className="7"
    />
  </Box>
))
